import LGBillTargetContainer from './Container'
import LGBillTargetsListContainer from './BillTargetsList'

export default {
    LGBillTargetContainer,
    LGBillTargetsListContainer
}